import styled from 'styled-components';

export {
  ArticlesContainer as MediaContainer,
  CountBadge,
  CountDelta,
  HeaderMeta,
  HeaderTitle,
  RefreshButton,
  RefreshStatusText,
  SectionHeader,
} from './ArticlesSection.styles';

export const MediaList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
`;
